import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableCellComponent, templateDataTableCell } from './DataTableCell';
import styles from './DataTableCell.styles.scss';
export const chameleonDataTableCell = DataTableCellComponent.compose({
    baseName: 'data-table-cell',
    template: templateDataTableCell,
    styles: withStylePrefix(styles),
});
